<!--
 * @Author: hzm
 * @Date: 2023-08-21 15:07:11
 * @Description: 
-->
<template>
  <div class="relative">
    <div class="wscn-http404-container">
      <div class="wscn-http404">
        <div class="pic-404">
          <img class="pic-404__parent" src="@/assets/404_images/404.png" alt="404" />
          <img class="pic-404__child left" src="@/assets/404_images/404_cloud.png" alt="404" />
          <img class="pic-404__child mid" src="@/assets/404_images/404_cloud.png" alt="404" />
          <img class="pic-404__child right" src="@/assets/404_images/404_cloud.png" alt="404" />
        </div>
        <div class="bullshit">
          <div class="bullshit__oops">404错误!</div>
          <div class="bullshit__headline">
            {{ message }}
          </div>
          <div class="bullshit__info">
            对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。
          </div>
          <router-link to="/" class="bullshit__return-home"> 返回首页 </router-link>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- <el-button type="primary" size="default" @click="createData">创建数据</el-button>
    <el-button type="primary" size="default" @click="clearData">清空数据</el-button>

    <div class="!flex space-x-2 flex-wrap">
      <div v-for="(item, index) in testData" :key="index" class="!w-1/4 p-2 bg-gray-100">
        {{ item }}
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  computed: {
    message() {
      return '找不到网页！';
    },
  },
  data() {
    return {
      testData: [],
      timer: [],
    };
  },
  methods: {
    averageFn(arr) {
      let i = 0; // 1. 从第0个开始截取
      let result = []; // 2. 定义结果，结果是二维数组
      while (i < arr.length) {
        // 6. 当索引等于或者大于总长度时，即截取完毕
        // 3. 从原始数组的第一项开始遍历
        result.push(arr.slice(i, i + 10)); // 4. 在原有十万条数据上，一次截取10个用于分堆
        i = i + 10; // 5. 这10条数据截取完，再截取下十条数据，以此类推
      }
      return result; // 7. 最后把结果丢出去即可
    },
    createData() {
      const arr = new Array(100000).fill(0).map((item, index) => index + 1);
      let twoData = this.averageFn(arr);
      console.log('this.testData', this.testData);
      const use2DArrItem = page => {
        // 4. 从第一项，取到最后一项
        if (page > twoData.length - 1) {
          console.log('每一项都获取完了');
          return;
        }
        // 5. 使用请求动画帧的方式
        this.timer.push(
          requestAnimationFrame(() => {
            // 6. 取出一项，就拼接一项（concat也行）
            this.testData = [...this.testData, ...twoData[page]];
            // 7. 这一项搞定，继续下一项
            page = page + 1;
            // 8. 直至完毕（递归调用，注意结束条件）
            use2DArrItem(page);
          })
        );
      };
      use2DArrItem(0);

      // for (let i = 0; i < twoData.length; i++) {
      //   // 相当于在很短的时间内创建许多个定时任务去处理
      //   this.timer.push(
      //     requestAnimationFrame(() => {
      //       this.testData = [...this.testData, ...twoData[i]]; // 赋值渲染
      //     })
      //   ); // 17 * i // 注意设定的时间间隔... 17 = 1000 / 60
      // }
    },
    clearData() {
      this.timer.forEach(item => {
        cancelAnimationFrame(item);
      });

      this.testData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.wscn-http404-container {
  // transform: translate(-50%, -50%);
  // top: 40%;
  // left: 50%;
}

.wscn-http404 {
  position: relative;
  width: 1200px;
  padding: 0 50px;
  overflow: hidden;

  .pic-404 {
    position: relative;
    float: left;
    width: 600px;
    overflow: hidden;

    &__parent {
      width: 100%;
    }

    &__child {
      position: absolute;

      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation-name: cloudLeft;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }

      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation-name: cloudMid;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1.2s;
      }

      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation-name: cloudRight;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }

      @keyframes cloudLeft {
        0% {
          top: 17px;
          left: 220px;
          opacity: 0;
        }

        20% {
          top: 33px;
          left: 188px;
          opacity: 1;
        }

        80% {
          top: 81px;
          left: 92px;
          opacity: 1;
        }

        100% {
          top: 97px;
          left: 60px;
          opacity: 0;
        }
      }

      @keyframes cloudMid {
        0% {
          top: 10px;
          left: 420px;
          opacity: 0;
        }

        20% {
          top: 40px;
          left: 360px;
          opacity: 1;
        }

        70% {
          top: 130px;
          left: 180px;
          opacity: 1;
        }

        100% {
          top: 160px;
          left: 120px;
          opacity: 0;
        }
      }

      @keyframes cloudRight {
        0% {
          top: 100px;
          left: 500px;
          opacity: 0;
        }

        20% {
          top: 120px;
          left: 460px;
          opacity: 1;
        }

        80% {
          top: 180px;
          left: 340px;
          opacity: 1;
        }

        100% {
          top: 200px;
          left: 300px;
          opacity: 0;
        }
      }
    }
  }

  .bullshit {
    position: relative;
    float: left;
    width: 300px;
    padding: 30px 0;
    overflow: hidden;

    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: $main-color;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }

    &__headline {
      font-size: 20px;
      line-height: 24px;
      color: #222;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }

    &__info {
      font-size: 13px;
      line-height: 21px;
      color: grey;
      opacity: 0;
      margin-bottom: 30px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }

    &__return-home {
      display: block;
      float: left;
      width: 110px;
      height: 36px;
      background: $main-color;
      border-radius: 100px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.3s;
      animation-fill-mode: forwards;
    }

    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }

      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
